export { default as useDeleteQuery } from './useDeleteQuery';
